import axiosInstance from '../axiosSetup';
import { toast } from 'react-toastify';
import axios from 'axios';

interface OpenDocumentOptions {
  url: string;
  params?: Record<string, any>;
  method?: 'GET' | 'POST';
  data?: any;
}

const withRandomParam = (value: string) => {
  if (!value) return value;
  if (value.includes('rd=')) return value;
  return `${value}${value.includes('?') ? '&' : '?'}rd=N`;
};

const withDefaultParams = (params?: Record<string, any>) => ({
  ...(params ?? {}),
  rd: params?.rd ?? 'N',
});

export const openDocumentInNewTab = async ({
  url,
  params,
  method = 'GET',
  data,
}: OpenDocumentOptions) => {
  if (!url) {
    toast.error('Document URL is missing');
    return;
  }

  try {

    const response = await axiosInstance({
      url,
      method,
      params: withDefaultParams(params),
      data,
    });

    const fileUrl =
      typeof response.data?.url === 'string'
        ? response.data.url
        : typeof response.data === 'string'
          ? response.data
          : '';

    if (fileUrl) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } else {
      toast.error('File URL is empty');
    }

  } catch (error) {

    console.error('Failed to open document:', error);

    if (
      axios.isAxiosError(error) &&
      error.response?.status === 404
    ) {
      toast.error('File not found');
    } else {
      toast.error('Failed to open document');
    }
  }
};

export const openDocumentFromUrl = async (url: string) => {
  if (!url) {
    toast.error('Document URL is missing');
    return;
  }

  try {
    const response = await axiosInstance.get(withRandomParam(url));

    const fileUrl =
      typeof response.data?.url === 'string'
        ? response.data.url
        : typeof response.data === 'string'
          ? response.data
          : '';

    if (fileUrl) {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    } else {
      toast.error('File URL is empty');
    }

  } catch (error) {

    console.error('Failed to open document from URL:', error);

    if (
      axios.isAxiosError(error) &&
      error.response?.status === 404
    ) {
      toast.error('File not found');
    } else {
      toast.error('Failed to open document');
    }
  }
};